export const GameTypeEnum = {
  SLOTS: 1,
  LIVE: 2,
  FISHING: 3,
  SPORT:4,
};
